import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { supabase } from 'src/lib/supabase'; // Import Supabase client

// Replace with your actual Hasura GraphQL endpoint URL
const HASURA_GRAPHQL_URL = import.meta.env.VITE_HASURA_GRAPHQL_URL;

if (HASURA_GRAPHQL_URL === 'YOUR_HASURA_GRAPHQL_ENDPOINT_HERE') {
  console.warn('Please replace YOUR_HASURA_GRAPHQL_ENDPOINT_HERE in src/layouts/overview/common/graphql.jsx with your actual Hasura GraphQL endpoint, or set VITE_HASURA_GRAPHQL_URL in your .env file.');
}

const httpLink = createHttpLink({
  uri: HASURA_GRAPHQL_URL,
});

const authLink = setContext(async (_, { headers }) => {
  const { data: { session }, error } = await supabase.auth.getSession();

  if (error) {
    console.error('Error getting Supabase session:', error);
    return { headers };
  }

  const token = session?.access_token;

  // Return the headers to the context so httpLink can read them
  if (token) {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
        'Content-Type': 'application/json', // Keep existing content-type or add if needed
      },
    };
  }

  return { headers };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default apolloClient;
